/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import integrationFieldsetTemplate from './integration-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function IntegrationDirective($compile, $templateCache, $translate, $document, types, utils, toast, integrationService) {

    var linker = function (scope, element) {
        var template = $templateCache.get(integrationFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.integration.httpEndpoint = null;
        refreshHttpEndpoint();

        scope.$watch('integration.configuration', function (newConfiguration, oldConfiguration) {
            if (!angular.equals(newConfiguration, oldConfiguration)) {
                scope.integration.configuration = newConfiguration;
                refreshHttpEndpoint();
            }
        });

        scope.integrationTypes = [];
        scope.integrationTypes.push(scope.types.integrationType.HTTP);
        scope.integrationTypes.push(scope.types.integrationType.MQTT);
        scope.integrationTypes.push(scope.types.integrationType.THINGSBOARD);
        scope.integrationTypes.push(scope.types.integrationType.AZURE);

        scope.integrationIdChanged = () =>{
            refreshHttpEndpoint()
        };

        scope.integrationTypeChanged = () => {
            if (!scope.integration.configuration) {
                scope.integration.configuration = {};
            }
            if (scope.integration.type == types.integrationType.HTTP.value) {
                scope.integration.configuration.port = 8080;
                scope.integration.configuration.basePath = '/';
                scope.integration.configuration.authMethod = types.authMethodType.NO_AUTH.value;
                refreshHttpEndpoint();
            } else if (scope.integration.type == types.integrationType.MQTT.value) {
                scope.integration.configuration.port = 1883;
                scope.integration.configuration.ssl = false;
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = null;
            } else if (scope.integration.type == types.integrationType.THINGSBOARD.value) {
                scope.integration.configuration.port = 1883;
                scope.integration.configuration.ssl = false;
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = null;
            } else if (scope.integration.type == types.integrationType.AZURE.value) {
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = utils.generateRandomToken(20);
            }

        };

        function refreshHttpEndpoint() {
            if (scope.integration.configuration) {
                if (scope.integration.configuration.routingKey == null) {
                    scope.integration.configuration.routingKey = utils.guid('');
                }

                scope.integration.httpEndpoint = integrationService.getIntegrationHttpEndpointLink(
                    scope.configuration,
                    scope.types.integrationType.HTTP.value,
                    scope.integration.configuration.routingKey);
            }
            return scope.integration.httpEndpoint;
        }

        $compile(element.contents())(scope);
    };
    return {
        restrict: "E",
        link: linker,
        scope: {
            integration: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/integration/integration.directive.js